__turbopack_context__.v({
  "buttonContainer": "CookieSettingsModal-module-scss-module__tV2xna__buttonContainer",
  "contentContainer": "CookieSettingsModal-module-scss-module__tV2xna__contentContainer",
  "switch": "CookieSettingsModal-module-scss-module__tV2xna__switch",
});
